import axiosClient from 'config/axiosClient';

const _url = '/Api/Classes';
const classService = {
	getAll: () => {
		return axiosClient.post(_url + '/GetAll');
	},
	getPaging: (option) => {
		return axiosClient.post(_url + '/GetPaging', option);
	},
	getDetail: (id) => {
		return axiosClient.post(_url + '/Get', { id: id });
	},
	createClass: (data) => {
		return axiosClient.post(_url + '/Create', data);
	},
	createNotificationClass: (data) => {
		return axiosClient.post(_url + '/CreateNotification', data);
	},
	updateClass: (data) => {
		return axiosClient.post(_url + '/Update', data);
	},
	deleteClass: (id) => {
		return axiosClient.post(_url + '/Delete', { id: id });
	},
	downloadTemplate: () => {
		return axiosClient.get(_url + '/Template', {
			responseType: 'arraybuffer',
			headers: {
				'Content-Type':
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			},
		});
	},
	importClass: (data, id) => {
		return axiosClient.post(_url + '/Import?facultyId=' + id, data);
	},
	exportClass: (id) => {
		return axiosClient.get(_url + '/Export?facultyId=' + id, {
			responseType: 'arraybuffer',
			headers: {
				'Content-Type':
					'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
			},
		});
	},
	getList: (option) => {
		return axiosClient.post(_url + '/GetList', option);
	},
};

export default classService;
